<template>

<div class="content-empty" v-bind:style="{'marginLeft': window.menuIndentContent}">

	<i class="fa-solid fa-face-frown-slight" />

	<h2 v-if="title">{{ title }}</h2>

	<p v-if="text">{{ text }}</p>

	<slot></slot>

</div>

</template>

<script>

export default {

	props: ['title', 'text']

}

</script>

<style scoped>

.content-empty {
	position: fixed;
	left: 320px;
	top: 88px;
	right: 0px;
	bottom: 0px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 0px;
	text-align: center;
	color: #fff;
	transition: margin-left 100ms linear;
}

.is-smaller .content-empty {
	top: 134px;
	left: 0px;
}

.is-tablet .content-empty {
	top: 134px;
	left: 0px;
}

.is-mobile .content-empty {
	top: 134px;
	left: 0px;
}

.content-empty i {
	font-size: 128px;
	margin-bottom: 20px;
	color: #4881bb;
}

.is-mobile .content-empty i {
	font-size: 96px;
}

.content-empty h2 {
	font-size: 32px;
	font-weight: 500;
	margin-bottom: 10px;
	color: #4881bb;
}

.is-mobile .content-empty h2 {
	font-size: 24px;
}

.content-empty p {
	font-size: 16px;
	padding: 0px 16px;
	color: #333;
}

.is-mobile .content-empty p {
	font-size: 14px;
}

</style>
